import {
  createFileRoute,
  Outlet,
  Navigate,
  Link,
} from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/auth/use-auth";
import { getRedirectPath } from "@/lib/get-redirect-path";
import Logo from "@/assets/icons/logo-blue.png";

const authSearchSchema = z.object({
  next: z.string().optional(),
});

export const Route = createFileRoute("/auth")({
  validateSearch: authSearchSchema,
  component: AuthLayout,
});

function AuthLayout() {
  // Get the session from the context
  const { authUser } = useAuth();
  const { next } = Route.useSearch();
  const redirectPath = next || getRedirectPath(authUser);

  // Redirect to the home page if there is a user
  if (authUser) {
    return <Navigate to={redirectPath} replace />;
  }

  // Otherwise, render the child components
  return (
    <div className="w-full bg-muted flex min-h-svh flex-col items-center justify-center p-6 md:px-10">
      <Link to="/auth/login">
        <img src={Logo} alt="Logo" className="max-h-8 mb-6" />
      </Link>
      <Outlet />
      {/* Shifts the form up just a tad */}
      <div className="mt-24" />
    </div>
  );
}
